import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/group-young-people-working-together-project_23-2148461544.jpg';

function EBT() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Electronic Benefits Transfer" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">Electronic Benefits Transfer (EBT)</h4>
              <p>
                Electronic Benefits Transfer (EBT) is an electronic system that allows SNAP recipients to receive and 
                use their benefits. EBT works like a debit card, making it easy and convenient to access your SNAP benefits 
                at authorized retailers.
              </p>
              <div style={{ marginTop: '20px' }}>
                <a
                  href="/new_pdfs_to_load/StateofGTS-ffy25-snap-et_state-plan%202.pdf"
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    padding: '8px 16px',
                    fontSize: '14px',
                    color: '#e75934',
                    textDecoration: 'none',
                    border: '1px solid #e75934',
                    borderRadius: '6px',
                    transition: 'all 0.2s ease',
                    backgroundColor: 'transparent',
                    width: 'fit-content'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#e75934';
                    e.currentTarget.style.color = '#fff';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.color = '#e75934';
                  }}
                >
                  <i className="fa-solid fa-file-pdf" style={{ marginRight: '8px', fontSize: '14px' }} />
                  Download EBT State Plan (PDF)
                </a>
              </div>
            </div>

            <div className="department-details-benefits-box">
              <h3>How EBT Works</h3>
              <div style={{ marginTop: '20px' }}>
                <div style={{ marginBottom: '24px' }}>
                  <h5 style={{ marginBottom: '8px', color: '#333', fontWeight: '600' }}>EBT Card</h5>
                  <p style={{ color: '#666', marginBottom: 0 }}>When you are approved for SNAP benefits, you will receive an EBT card in the mail. This card looks and works like a regular debit card.</p>
                </div>
                <div style={{ marginBottom: '24px' }}>
                  <h5 style={{ marginBottom: '8px', color: '#333', fontWeight: '600' }}>Personal Identification Number (PIN)</h5>
                  <p style={{ color: '#666', marginBottom: 0 }}>Your EBT card comes with a Personal Identification Number (PIN) that you will use to access your benefits. Keep your PIN secure and never share it with anyone.</p>
                </div>
                <div style={{ marginBottom: '0' }}>
                  <h5 style={{ marginBottom: '8px', color: '#333', fontWeight: '600' }}>Using Your EBT Card</h5>
                  <p style={{ color: '#666', marginBottom: 0 }}>You can use your EBT card at any authorized SNAP retailer. Simply swipe your card at the point of sale terminal and enter your PIN to complete the transaction.</p>
                </div>
              </div>
            </div>

            <div className="department-details-box">
              <div className="department-details-policy">
                <span>
                  EBT provides a secure and convenient way to access SNAP benefits.
                </span>
              </div>
              <p>
                The State of GTS is committed to ensuring that EBT is accessible, secure, and easy to use for all SNAP recipients.
              </p>
            </div>

            <div className="department-details-benefits-inner-box">
              <h3>Where Can You Use Your EBT Card?</h3>
              <p>
                Your EBT card can be used at a wide variety of authorized retailers, including:
              </p>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-check-circle" style={{ color: '#28a745', marginRight: '10px' }} />
                  Grocery stores and supermarkets
                </li>
                <li>
                  <i className="fa-solid fa-check-circle" style={{ color: '#28a745', marginRight: '10px' }} />
                  Farmers markets (where EBT is accepted)
                </li>
                <li>
                  <i className="fa-solid fa-check-circle" style={{ color: '#28a745', marginRight: '10px' }} />
                  Convenience stores that are authorized SNAP retailers
                </li>
                <li>
                  <i className="fa-solid fa-check-circle" style={{ color: '#28a745', marginRight: '10px' }} />
                  Online retailers (where available)
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Online Grocery Purchasing</h4>
              <p>
                SNAP recipients can now use their EBT cards to purchase groceries online from participating retailers. 
                This service provides greater convenience and access to food, especially for those who may have difficulty 
                visiting physical stores.
              </p>
              <p style={{ marginTop: '15px' }}>
                <strong>Important:</strong> EBT cards can only be used for approved grocery items. Delivery fees and other 
                non-food items cannot be purchased with your EBT card.
              </p>
              <p style={{ marginTop: '15px' }}>
                To determine if grocery delivery is available for your location, please visit the retailers' websites 
                or contact your local Department of Family and Children Services office.
              </p>
            </div>

            <div className="department-details-policy-box">
              <h4>Checking Your Balance</h4>
              <p>
                You can check your EBT balance in several ways:
              </p>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Check your receipt after making a purchase (your balance is printed on the receipt)
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Call the EBT customer service number on the back of your card
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Log in to your online EBT account (where available)
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Visit an ATM that displays EBT balances
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Protecting Your EBT Card</h4>
              <p>
                To protect your EBT card and benefits:
              </p>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Never share your PIN with anyone
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Keep your card in a safe place
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Report a lost or stolen card immediately
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Check your balance regularly to monitor for unauthorized transactions
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Contact customer service if you notice any suspicious activity
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Replacing a Lost or Stolen Card</h4>
              <p>
                If your EBT card is lost or stolen, contact the EBT customer service number immediately. 
                A replacement card will be issued, and any remaining benefits will be transferred to your new card.
              </p>
              <p style={{ marginTop: '15px' }}>
                <strong>Note:</strong> There may be a fee for replacing a lost or stolen card. Contact customer service 
                for more information about replacement card fees and procedures.
              </p>
            </div>

            <div>
              <Link to="/department/family-services/snap">
              <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }}/>
              Back to SNAP
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default EBT;

